<template>
  <div class="index">
    <Header></Header>
    <hr />
    <div class="home-box">
      <div class="content-home">
        <div class="home-header">{{$t('T_TOP_TITLE_EPSON')}} {{$t('T_TOP_TITLE')}}</div>
        <ul class="home-ul">
          <li v-if="functionEnable('Search')">
              <div class="li1" @click="changeRouter('Search')">
                <div class="home-img-0 image"></div>
                <div class="home-title">
                  <div class="home-text">{{$t('T_SEARCH_MODEL')}}</div>
                  <div class="home-des">{{$t('T_TOPVIEW_SEARCH_PROJECTOR')}}</div>
                </div>
              </div>
          </li>
          <li v-if="functionEnable('Categolies')">
              <div class="li1" @click="changeRouter('Categolies')">
                <div class="home-img-1 image"></div>
                <div class="home-title">
                  <div class="home-text">{{$t('T_SEARCH_CATEGORY')}}</div>
                  <div class="home-des">{{$t('T_TOPVIEW_CATEGORIES')}}</div>
                </div>
              </div>
          </li>
          <li v-if="functionEnable('Specification')">
            <div class="li1" @click="changeRouter('Specification')">
              <div class="home-img-2 image"></div>
              <div class="home-title">
                <div class="home-text">{{$t('T_SEARCH_SPEC')}}</div>
                <div class="home-des">{{$t('T_TOPVIEW_SPECIFICATION')}}</div>
              </div>
            </div>
          </li>
          <li v-if="functionEnable('InstallCondition')">
            <div class="li1" @click="changeRouter('InstallCondition')">
              <div class="home-img-3 image"></div>
              <div class="home-title">
                <div class="home-text">{{$t('T_SEARCH_CONDITION')}}</div>
                <div class="home-des">{{$t('T_TOPVIEW_CONDITION')}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
import Header from '../components/header'
import Footer from '../components/footer'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  data () {
    return {
      topOffset: 24,
      TopPath: 'basicMode'
    }
  },

  components: {
    Header,
    Footer
  },

  computed: {
    ...mapState([
      'searchTabActive',
      'houseInfo',
      'selectedModelData',
      'selectedLensData',
      'bmMatchingModelData',
      'bmSelectedModelData',
      'bmMatchingLensID',
      'bmSelectedLensData',
      'cateRadio',
      'htmMatchingModelData',
      'htmSelectedModelData',
      'htmSelectedLensData'
    ])
  },

  created () {
    // initMain = 0 进入top页面, initMain = 1 进入index画面
    if (this.InitConfig.initMain === 1) {
      if (this.InitConfig.initSimulator === 'Advanced') {
        this.SET_SEARCHTABACTIVE(this.InitConfig.initSearchTab)
        this.$router.push('/page/advanceMode')
      } else {
        this.SET_SEARCHTABACTIVE(this.InitConfig.initSearchTab)
        this.$router.push('/page/basicMode')
      }
    }
    // this.$router.push('/maintenance')
  },

  mounted () {},

  methods: {
    ...mapMutations([
      'SET_SEARCHTABACTIVE', 'PJZ', 'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA', 'BMSELECTEDMODELDATA', 'BMMATCHINGLENSID',
      'BMSELECTEDLENSDATA', 'BMMATCHINGMODELDATA', 'SET_FROMBLENDING', 'SET_TABACTIVENAME'
    ]),

    changeRouter (router) {
      this.SET_SEARCHTABACTIVE(router)
      this.SET_FROMBLENDING(false)
      this.SET_TABACTIVENAME(this.InitConfig.initSimulator)

      this.$router.push({
        path: '/page/' + this.TopPath
      })
    },
    functionEnable (value) {
      return this.InitConfig.initFunction.indexOf(value) !== -1
    },
    onmousedown (e) {
      let ev = e || event
      let oldY = ev.clientY
      let PJTop = this.$refs['varrow'].offsetTop

      document.onmousemove = ev => {
        // event的兼容性
        let e = ev || event
        // 获取鼠标移动时的坐标
        let newY = e.clientY
        // 计算出鼠标的Y方向移动距离
        let moveY = newY - oldY
        let top = moveY + PJTop + this.topOffset
        this.$refs['varrow'].style.top = top + 'px'
      }
      // 清除
      document.onmouseup = ev => {
        document.onmousemove = null
      }
    }
  }
}

</script>
<style scoped>
  .arrimg {
    width: 34px;
    height: 95px;
    background: url('../assets/parts/UST/btn_move.png') no-repeat;
    margin: auto;
  }

  .v-arrow {
    position: absolute;
    left: 195px;
    top: 20px;
  }

  .screen {
    position: relative;
    top: 20px;
    width: 40px;
    height: 200px;
    background: url("../assets/parts/UST/screen_side.png") no-repeat;
    background-size: cover
  }

  .leftArrow {
    left: -12px;
    bottom: -7px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-right-color: inherit;
  }

  .middle {
    height: 2px;
    position: relative;
    width: 100px;
    background: blue;
  }

  .arrow {
    position: relative;
  }

  .container {
    position: relative;
    left: 100px;
  }

  .vertical {
    transform: rotate(90deg);
    transform-origin: left top;
    -ms-transform: rotate(90deg);
    /* Internet Explorer */
    -moz-transform: rotate(90deg);
    /* Firefox */
    -webkit-transform: rotate(90deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(90deg);
  }

  .rightArrow {
    bottom: 7px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-left-color: inherit;
  }

  .left {
    width: 2px;
    height: 16px;
    background: blue;
    position: relative;
    left: -8px;
    bottom: -21px;
  }

  .right {
    width: 2px;
    height: 16px;
    background: blue;
    position: relative;
    bottom: 21px;
  }
  .home-ul{
    padding-bottom:30px;
  }
  .home-box {
    height: 752px;
    background-color: #f0f0f0;
    overflow-y: auto;
  }

  .home-box li .home-title {
    font-weight: 400;
    font-size: 20px;
    float: left;
    width: 49%;
    margin-top: 20px;
  }

  .home-box li .home-des {
    color: #666666;
    margin-top: 15px;
    font-size: 14px;
  }

  .home-box ul li {
    width: 1000px;
    margin: auto;
  }

  .li1 {
    background: #fff;
    border: 1px solid #cccccc;
    height: 140px;
    margin-top: 20px;
  }

  .li1:hover {
    border: 1px solid #10218b;
  }

  .home-button {
    border: none;
  }

  .image {
    width: 48%;
    height: 120px;
    float: left;
    margin: 10px;
  }

  .home-img-0 {
    background: url('../assets/parts/top/img_search.png') no-repeat;
    background-size: cover;
  }

  .home-img-1 {
    background: url('../assets/parts/top/img_categories.png') no-repeat;
    background-size: cover;
  }

  .home-img-2 {
    background: url('../assets/parts/top/img_sepcification.png') no-repeat;
    background-size: cover;
  }

  .home-img-3 {
    background: url('../assets/parts/top/img_condition.png') no-repeat;
    background-size: cover;
  }

  .home-header {
    text-align: center;
    font-size:24px;
    font-family:Microsoft Sans Serif;
    font-weight:400;
    padding-top: 40px;
  }

  .home-text {
    color: #000;
  }

  .disabled {
    background: #cccccc;
    cursor: no-drop;
    line-height: 16px!important;
  }

  .disabled:hover {
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/page/top.vue